import util from '@/libs/util'

const post = util.ajax.post

export const registermainUrls = [
  // 查询到店登记列表
  '/appointment/list',
  // 到店登记确认
  '/appointment/arriveStore',
  // 撤销到店
  '/appointment/backToAppointed'
]

export const registermain = {}

registermain.list = function (params) {
  return post('/appointment/list', params)
}
registermain.arriveStore = function (params) {
  return post('/appointment/arriveStore', params)
}
registermain.backToAppointed = function (params) {
  return post('/appointment/backToAppointed', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/register/registermain.js